import { useContext } from 'react';
import { PopoverContext } from './Popover';

export default function usePopover() {
  return useContext(PopoverContext);
}
